import "@aws-amplify/ui-react/styles.css";
import { Box, Grid } from "@mui/material";
import cambioPassword from "./img/cambio-password.png";
import shapeBottom from "./img/shapeBottom.svg";
import shapeTop from "./img/shapeTop.svg";
import {
  ActionButton,
  BodyText,
  DecorativeShape,
  Title,
} from "./LoginInfoParts";

const ILLUSTRATION = cambioPassword;
const PASSWORD_GUIDE_URL =
  "http://ummia.cl/wp-content/uploads/2025/07/cambiar-contrasena-app-ummia.pdf";
const HOSTNAME = window.location.hostname;
const isAR =
  HOSTNAME.includes("ar-dev.ummia.ai") || HOSTNAME.includes("ar-qa.ummia.ai");

const LoginInfo = () => {
  return (
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        backgroundColor: isAR ? "#EFF7F9" : undefined,
        backgroundImage: !isAR
          ? "linear-gradient(to bottom, #F9DA96 30%, #F9BA32 100%)"
          : undefined,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
        position: "relative",
      }}
    >

      {/* Fondo decorativo */}
      <DecorativeShape src={shapeTop} position="top" />
      <DecorativeShape src={shapeBottom} position="bottom" />

      <Box textAlign="center" maxWidth={700} sx={{ zIndex: 2 }}>
        <Box
          component="img"
          src={ILLUSTRATION}
          alt="Ilustración escritorio"
          sx={{
            maxWidth: { xs: "30%", sm: "40%", md: "50%" },
            height: "auto",
            mb: 1,
          }}
        />

        <Title>Estamos creciendo para ofrecerte más.</Title>

        <BodyText>
          Por seguridad y mejoras en nuestra plataforma, te recomendamos 
          <strong> actualizar tu contraseña al ingresar.</strong>.
        </BodyText>


        <ActionButton url={PASSWORD_GUIDE_URL} />
      </Box>
    </Grid>
  );
};

export default LoginInfo;
